import React from 'react'
import PanelStyleContextProvider, {
    PanelStyleContext,
} from './PanelStyleContext'
import ExpandedOverlay from './ExpandedOverlay'

const Panel = ({ panelClassConfig, componentWidth, children }) => (
    <PanelStyleContextProvider componentWidth={componentWidth} panelClassConfig={panelClassConfig}>
        <PanelStyleContext.Consumer>
            {value => (
                <ExpandedOverlay>
                    <div
                        className={`dashboardPanel ${
                            value.panelClassName ? value.panelClassName : ''
                        }`}
                    >
                        <div
                            className={`dashboardPanelShadow dashboardPanelBody`}
                        >
                            {children}
                        </div>
                    </div>
                </ExpandedOverlay>
            )}
        </PanelStyleContext.Consumer>
    </PanelStyleContextProvider>
)

export default Panel
